var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PropertySelect',{staticClass:"property-alarm-new",attrs:{"prop-model":_vm.propModel,"is-read-only":false,"value":null,"show-icon":_vm.showIcon},on:{"update:value":_vm.addReminderFromSelect}})
}
var staticRenderFns = []

export { render, staticRenderFns }